import * as React from 'react';

import type { InputProps, InternalInputProps } from './Input.types';
import classes from './Input.module.css';
import { Text } from '../Text';
import clsx from 'clsx';
import { ErrorIcon, SuccessIcon } from '../../assets/icons';

export const Input = (props: InputProps) => {
    const {
        type,
        readonly,
        disabled,
        onChange,
        onClick,
        value,
        label,
        helperText,
        placeholder,
        status,
        icon,
        inputClassName,
        className,
        required,
        id,
    } = props;
    const { hintText, children, onKeyDown } = props as InternalInputProps;
    return (
        <div className={clsx(classes.root, className)}>
            {label && (
                <label data-testid={id + '-label'}>
                    <Text fontWeight="semibold" text={label} />
                </label>
            )}
            {hintText && (
                <div data-testid={id + '-hint-text'}>
                    {' '}
                    <Text text={hintText} size="xs" />{' '}
                </div>
            )}
            <div className={classes['dropdown-wrapper']}>
                <div className={classes['input-wrapper']}>
                    <input
                        data-testid={id + '-input-cmp'}
                        autoComplete="off"
                        type={type}
                        readOnly={readonly}
                        disabled={disabled}
                        onChange={onChange}
                        value={value}
                        placeholder={placeholder}
                        className={clsx(classes.input, classes[`${status}`], inputClassName, { [classes.hasIcon]: icon })}
                        onKeyDown={onKeyDown}
                        onClick={onClick}
                        required={required}
                    />
                    {icon && (
                        <div data-testid={id + '-input-icon'} className={classes.icon}>
                            {icon}
                        </div>
                    )}
                </div>
                {children}
            </div>

            {helperText && (
                <div className={classes['helper-wrapper']} data-testid={id + '-helper-text'}>
                    {status === 'error' && <ErrorIcon className={classes['error-icon']} />}
                    {status === 'success' && <SuccessIcon className={classes['success-icon']} />}
                    <Text text={helperText} size="xs" className={classes[`${status}-label`]} />
                </div>
            )}
        </div>
    );
};

Input.displayName = 'Input';

export const DropdownInput = (props: InternalInputProps) => {
    return <Input {...props} />;
};
